import { NexoyaFunnelStepType } from '../../../../../types';

export const ACTIONS_HEADER_ID = 'actionsHeader';
export const SELECT_HEADER_ID = 'selectHeader';
export const CHANNEL_HEADER_ID = 'channelHeader';
export const IMPACT_GROUP_HEADER_ID = 'impactGroupHeader';
export const LABEL_HEADER_ID = 'labelHeader';
export const ATTRIBUTION_GROUP_HEADER_ID = 'attributionGroupHeader';
export const IDS_NOT_ALLOWED_TO_HIDE = [
  ACTIONS_HEADER_ID,
  CHANNEL_HEADER_ID,
  IMPACT_GROUP_HEADER_ID,
  ATTRIBUTION_GROUP_HEADER_ID,
];

export const isConversionValueFunnelStep = (funnelStepType: NexoyaFunnelStepType) =>
  funnelStepType === NexoyaFunnelStepType.ConversionValue;

export const isCostFunnelStep = (funnelStepType: NexoyaFunnelStepType) => funnelStepType === NexoyaFunnelStepType.Cost;
